// extracted by mini-css-extract-plugin
export var chevron = "_li-3";
export var chevronRotated = "_li-4";
export var image = "_li-1";
export var imageContainer = "_li-0";
export var shippingAddress = "_li-2";